var hostPath = window.location.host
hostPath = hostPath.replace(/:.*/, "");

// const isLocalHost = ['127.0.0.1', 'localhost'].includes(hostPath)
const isLocalHost = false;


export function getGisBaseUrl() {
	if (isLocalHost) {
		return 'http://149.248.21.233';
	} else {
		return 'http://149.248.21.233';
	}
}
export function getAxiosBaseUrl() {
	const isLocalHost = false;
	if (isLocalHost) {
		return 'http://127.0.0.1:' + getPythonPort();
	} else {
		return 'https://applyjobs.ai:' + getPythonPort();
	}
}

export function getBaseUrlNodeServer() {
	const isLocalHost = false;
	if (isLocalHost) {
		return 'http://127.0.0.1:8080/'
	} else {
		return 'https://applyjobs.ai:8080/'
	}
}



export function getPythonPort() {
	return '5001'
}

export const API_URL = process.env.NODE_ENV === 'production'
  ? 'http://quantussoftware.in:8080'
  : 'http://localhost:8080'